import { makeStyles } from 'tss-react/mui';

const useStylesHeaderSubmenuItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  headerSubmenuItem: {
    '&:empty': {
      display: 'none',
    },
    '& button': {
      padding: '0 15px !important',
      marginTop: '8px !important',
      color: theme.palette.common.white,
      [theme.breakpoints.down('md')]: {
        padding: '0 10px !important',
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
        padding: '6px 6px 6px 4px !important',
      },
    },
    '&:first-of-type': {
      [theme.breakpoints.down('sm')]: {
        marginLeft: '-15px !important',
      },
    },
    '&:last-of-type': {
      '& > span > button': {
        marginTop: '0 !important',
      },
    },
  },
  headerSubmenuItemActive: {
    background: theme.palette.primary.light,
    borderRadius: 5,
    '& button': {
      color: theme.palette.secondary.main,
    },
  },
}));

export default useStylesHeaderSubmenuItem;
